<template>
  <div class="Registers">
    <header class="navigation-header">
      <nav class="tabs-container">
        <button
          v-for="item in tabs"
          :key="item.text"
          class="tab-button"
          :class="{ active: selectedTabLabel === item.value }"
          @click="storeLabelTabName(item.text)"
        >
          {{ item.text }}
          <span class="indicator"></span>
        </button>
      </nav>
    </header>

    <main class="content-viewport">
      <transition name="fade-slide" mode="out-in">
        <div :key="selectedTabLabel" class="tab-content">
          <div v-if="selectedTabLabel === 'Clientes'" class="table-card">
            <CustomerTable />
          </div>
          <div v-if="selectedTabLabel === 'Produtos'" class="table-card">
            <ProductsTable />
          </div>
          <div v-if="selectedTabLabel === 'Fornecedores'" class="table-card">
            <SupplierTable @supplierLenght="supplierLenght = $event" />
          </div>
          <div v-if="selectedTabLabel === 'Funcionários'" class="table-card">
            <EmployeeTable />
          </div>
        </div>
      </transition>
    </main>

    <div :class="sizeModalRegister">
      <div :class="modalContainer" v-if="colapseRegister">
        <div class="modal-body">
          <CustomerMobile
            class="form-container"
            v-if="this.typeRegister.customer"
            :onClose="modalHeight"
          />
          <SupplierMobile
            class="form-container"
            v-if="this.typeRegister.supplier"
            :onClose="modalHeight"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomerMobile from "../Customer/CustomerMobile.vue";
import SupplierMobile from "../Supplier/SupplierMobile.vue";
import CustomerTable from "./MobileTables/customer.vue";
import ProductsTable from "./MobileTables/products.vue";
import SupplierTable from "./MobileTables/supplier.vue";
import EmployeeTable from "./MobileTables/employee.vue";

import { mapMutations, mapState } from "vuex";
import serviceRegisters from "../../services/serviceRegisters";

export default {
  components: {
    CustomerMobile,
    SupplierMobile,
    CustomerTable,
    ProductsTable,
    SupplierTable,
    EmployeeTable,
  },
  data() {
    return {
      counter: {},
      tableActive: {
        customer: true,
        supplier: false,
        employee: false,
        products: false,
      },
      supplierLenght: 0,
      selectedTabLabel: "Clientes",
      tabs: [
        { value: "Clientes", text: "Clientes" },
        { value: "Fornecedores", text: "Fornecedores" }
      ],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_CUSTOMER",
      "SET_DATA_SEARCH_FROM_EMPLOYEE",
      "SET_DATA_SEARCH_FROM_PRODUCT",
      "SET_DATA_SEARCH_FROM_SUPPLIER",
    ]),

    async activeTable(event) {
      const button = event.currentTarget;
      const name = button.name;
      this.tableActive = {
        customer: false,
        supplier: false,
        employee: false,
        products: false,
        [name]: true,
      };
    },
    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
    },
    async countAll() {
      try {
        this.counter = await serviceRegisters.countAll();
      } catch (error) {
        console.log(error.response);
      }
    },

    async modalHeight() {
      this.SET_COLAPSE_REGISTER(!this.colapseRegister);
      this.colapseRegister
        ? this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral")
        : this.ALTER_SIZE_MODAL_REGISTER("disable");
      this.modalContainer
        ? this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer")
        : this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");

      if (!this.colapseRegister && this.sizeModalRegister === "disable") {
        this.SET_DATA_SEARCH_FROM_CUSTOMER({});
        this.SET_DATA_SEARCH_FROM_EMPLOYEE({});
        this.SET_DATA_SEARCH_FROM_PRODUCT({});
        this.SET_DATA_SEARCH_FROM_SUPPLIER({});
      }
      this.countAll();
    },

    async handleModals(event) {
      const name = event.target.name;
      this.ALTER_TYPE_REGISTER(name);

      this.modalHeight();
    },
  },
  computed: {
    ...mapState({
      sizeModalRegister: (state) => state.sizeModalRegister,
      typeRegister: (state) => state.typeRegister,
      colapseRegister: (state) => state.colapseRegister,
      modalContainer: (state) => state.modalContainer,
    }),
  },
  created() {
    this.SET_COLAPSE_REGISTER(false);
    this.SET_DATA_SEARCH_FROM_CUSTOMER({});
    this.SET_DATA_SEARCH_FROM_EMPLOYEE({});
    this.SET_DATA_SEARCH_FROM_PRODUCT({});
    this.SET_DATA_SEARCH_FROM_SUPPLIER({});
    this.ALTER_SIZE_MODAL_REGISTER("disable");
    this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");
    this.countAll();
  },
};
</script>
<style scoped>
:root {
  --primary-color: #006458;
  --bg-color: #f4f7f6;
  --white: #ffffff;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.Registers {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f4f7f6;
  overflow: hidden;
  font-family: "Inter", sans-serif;
}

.navigation-header {
  background: #006256;
  color: white !important;
  padding: 0 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  z-index: 10;
}

.tabs-container {
  display: flex;
  gap: 30px;
  height: 60px;
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}

.tab-button {
  background: none;
  border: none;
  padding: 0;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  position: relative;
  transition: var(--transition);
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.tab-button.active {
  color: #006458;
  background: white;
  border-radius: 8px;
  padding: 3px 15px;
}

.indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: #006458;
  transition: var(--transition);
  border-radius: 3px 3px 0 0;
}

.tab-button.active .indicator {
  width: 100%;
}

.content-viewport {
  flex: 1;
  overflow-y: auto;
  padding: 25px;
  scroll-behavior: smooth;
}

.table-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
  min-height: 80vh;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}
.fade-slide-enter {
  opacity: 0;
  transform: translateX(30px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.ModalGeneral {
  position: fixed !important;
  inset: 0;
  z-index: 1000;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.5s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.modal-header {
  padding: 15px 25px;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #eee;
}

.btn-close-modern {
  background: #f0f0f0;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: var(--transition);
}

.btn-close-modern:hover {
  background: #ff4d4d;
  color: white;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  height: 100vh;
  padding: 10px;
}

.form-container {
  max-width: 900px;
  margin: 0 auto;
  margin-bottom: 24px;
}

.disable {
  display: none;
}

@media screen and (max-width: 768px) {
  .Registers {
    margin-left: 0;
  }

  .tabs-container {
    gap: 15px;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .tabs-container::-webkit-scrollbar {
    display: none;
  }

  .tab-button {
    white-space: nowrap;
    font-size: 0.85rem;
  }

  .content-viewport {
    padding: 2px;
  }
}
</style>